<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 verify-account">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                

                            </div>
                        </div>
                        <div class="card card-title">
                           <h3>Verify your account</h3>
                        </div>
                        <div class="card-body text-center">
                            <form v-if="wallet_exist == 0" action="/redeem/verify" enctype="multipart/form-data" method="POST">
                                <div class="form-group">
                                    <label for="company_email">Email address</label>
                                    <input type="email" class="form-control" name="company_email" id="company_email" v-bind:value="company_email" aria-describedby="emailHelp" required="" />
                                    <small id="emailHelp" class="form-text text-muted">Your wallet email registered.</small>
                                </div>
                                <div class="form-group">
                                    <div style="width: 100%;overflow: hidden;margin: 0 auto 5px;max-width: 304px;position: relative;clear: both;">
                                        <vue-recaptcha sitekey="6Lf75zEUAAAAAI3SawkXu1GCgLeDaZbfvudKzDMX" :loadRecaptchaScript="true"></vue-recaptcha>
                                    </div>
                                </div>
                                <button type="submit" name="submit" class="btn btn-verify">Submit</button>

                                <div v-if="is_submitted == 1" class="alert" :class="'alert-'+classType" role="alert">
                                    {{ this.message }}
                                </div>

                            </form>

                            <div v-if="wallet_exist == 1" >
                                <span class="mobile-text">Enter the code we just send on your email <b class="text-danger">{{ this.company_email }}</b></span>
                                <div class="mt-3">
                                    <div class="otp">
                                        <v-otp-input
                                          ref="otpInput"
                                          input-classes="otp-input"
                                          separator=""
                                          :num-inputs="6"
                                          :should-auto-focus="true"
                                          :is-input-num="true"
                                          @on-change="handleOnChange"
                                          @on-complete="handleOnComplete"
                                        />
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button class="btn btn-verify mb-2" @click="verifyOTP()">Submit</button>

                                    <span class="d-block">Don't receive the code?</span>
                                    <a href="" class="font-weight-bold text-danger cursor">Resend</a>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }

    .verify-account .otp-input {
        width: 50px;
        height: 50px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
    }
    .verify-account .otp{

    }
    .verify-account .otp .otp-input.error {
        border: 1px solid red !important;
    }
    .verify-account .otp .otp-input::-webkit-inner-spin-button,
    .verify-account .otp .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
<style scoped>
    .verify-account{
        max-width: 500px;
        margin: 0 auto;
    }
    .verify-account .card-header{
        background-color: #DE3C4C;
    }
    .verify-account .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .verify-account .card-body{
        padding: 20px 20px 40px; 
    }
    .verify-account .card-title{
        border: 0;
        margin: 0;
    }
    .verify-account .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }

    .verify-account input{
        text-align: center;
        max-width: 302px;
        margin: 0 auto;
    }

    .verify-account button.btn-verify{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
        max-width: 302px;
        margin: 0 auto;
    }
    .verify-account button.btn-verify:hover, .verify-account button.btn-verify:focus{
        outline: 0;
        border: 0;
    }

    .verify-account .alert{
        margin: 15px 0 0;
    }



</style>

<script>

    import VueRecaptcha from 'vue-recaptcha'
    import OtpInput from "@bachdgvn/vue-otp-input";

     export default {
        components: { 
            VueRecaptcha, 
            "v-otp-input" : OtpInput,
        },
        props: ['data'],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            company_email: "",
            redirect: "",
            classType: "",
            message: "",
            is_submitted: "",
            wallet_exist: "",
        }), 
        mounted() {

            const data = JSON.parse(this.data)
            console.log(data);

            this.company_email = data.company_email;
            this.redirect = data.redirect;
            this.classType = data.class;
            this.message = data.message;
            this.is_submitted = data.is_submitted;
            this.wallet_exist = data.wallet_exist;

        },
        methods: {
            handleOnComplete(value) {
              console.log('OTP completed: ', value);
            },
            handleOnChange(value) {
              console.log('OTP changed: ', value);
            },
            handleClearInput() {
              this.$refs.otpInput.clearInput();
            },
            verifyOTP: function () {

                let otp = "";
                //otp = otp.join('');
                //alert(this.company_email);
                
                $('input[type="tel"].otp-input').each(function () {
                    //console.log($(this).val());
                    otp = otp.concat($(this).val())
                });
                console.log(otp);

            }
        }
    }



</script>
